import { sizeToNumber } from './sizeToNumber';
export const getImageWidth = (size = 1, vw, pixelRatio) => {
    // Convert input size to fraction or px value
    size = sizeToNumber(size);
    // Size is in px
    if (size > 2) {
        return Math.round(size * pixelRatio);
    }
    // Size is a fraction
    return Math.round(vw * size * pixelRatio);
};
//# sourceMappingURL=getImageWidth.js.map